export default __webpack_public_path__ + "static/media/NotesIcon.b88ade49.svg";